import React from 'react'
import ReactDOM from 'react-dom/client'
import './utils/dateUtils'
import App from './app'
import { BrowserRouter as Router } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "./styles/toastify.overrides.css";
import "./styles/tokens.css";
import AppThemeProvider from './components/app-theme-provider';
import reportWebVitals from './reportWebVitals';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Router>
        <AppThemeProvider>
            <App />
        </AppThemeProvider>
    </Router>
  </React.StrictMode>
)

reportWebVitals();
